export default function CTASection() {
  return (
    <section className="relative w-full py-32 md:py-40 flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Beautifully%20styled%20lifestyle%20flat%20lay%20with%20fashion%20shopping%20essentials%20including%20designer%20handbag%20folded%20cashmere%20scarf%20leather%20wallet%20and%20delicate%20gold%20jewelry%20arranged%20on%20light%20oak%20wood%20surface%2C%20soft%20afternoon%20sunlight%20with%20gentle%20shadows%2C%20potted%20olive%20branch%20in%20ceramic%20vase%2C%20cream%20and%20warm%20terracotta%20tones%2C%20editorial%20product%20photography%20with%20sophisticated%20minimalist%20aesthetic%20and%20airy%20natural%20composition&width=1920&height=900&seq=cta-main-bg-v3&orientation=landscape"
        alt="Superbuy Spreadsheet shopping resources background"
        title="Get Superbuy Spreadsheet Resources Now"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/40 to-foreground-950/60"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-10">
          <div className="lg:max-w-xl">
            <h2 className="font-heading text-4xl md:text-6xl font-bold text-background-50 mb-4 leading-tight">
              Ready To Upgrade
              <br />
              Your Haul?
            </h2>
            <p className="text-background-50/80 text-sm md:text-base leading-relaxed max-w-md">
              Access the complete Superbuy Spreadsheet resource collection. All links safe, verified, and organized for your convenience. Start discovering better products today.
            </p>
          </div>

          <div className="flex flex-col items-start gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="bg-background-50 hover:bg-background-100 text-foreground-950 px-8 py-4 rounded-full text-base font-semibold whitespace-nowrap cursor-pointer transition-all duration-300 flex items-center gap-3 group"
            >
              Get Superbuy Sheet Now
              <div className="w-8 h-8 rounded-full bg-foreground-950 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                <i className="ri-arrow-right-line text-background-50 text-sm"></i>
              </div>
            </a>
            <p className="text-background-50/60 text-xs">
              Redirects safely to kaspreadsheet.com — your trusted shopping destination
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}